import { loadScript } from '@golden/shared';
import { Lang } from './types';
import { BotionError } from './BotionError';
export let isBotionInited = false;
export const initBotion = async (urlHelper, captchaId, overrideOptions = {}) => {
    const staticServers = [
        urlHelper.get('botionStatic'),
        urlHelper.get('netshuntStatic')
    ];
    const apiServers = [
        urlHelper.get('botionBcaptcha'),
        urlHelper.get('netshuntBcaptcha')
    ];
    const load = async () => {
        if (!isBotionInited) {
            for (const source of staticServers.map((s) => `${s}/v1/boc.js`)) {
                try {
                    await loadScript(source);
                    isBotionInited = true;
                    break;
                }
                catch (e) {
                    continue;
                }
            }
            if (!isBotionInited) {
                throw new Error('botion scripts load failed');
            }
        }
    };
    const init = async () => await new Promise((resolve, reject) => {
        if (!window.initBotion) {
            reject(new BotionError('init', 'botion scripts load failed'));
            return;
        }
        window.initBotion({
            captchaId,
            language: Lang.ZHO,
            product: 'bind',
            nativeButton: {
                width: '100%'
            },
            protocol: `${urlHelper.clientProtocol}//`,
            apiServers: apiServers.map((s) => s.replace('https://', '')),
            staticServers: staticServers.map((s) => s.replace('https://', '')),
            fallback_config: {
                bypass: {
                    staticServers: staticServers.map((s) => s.replace('https://', '')),
                    type: 'bypass',
                    bypass: '/v1/bypass.js'
                }
            },
            timeout: 60000,
            onError: (e) => {
                reject(new BotionError('init', e));
            },
            ...overrideOptions
        }, (captcha) => {
            captcha.onReady(() => {
                resolve(captcha);
            });
        });
    });
    await load();
    const captcha = await init();
    const show = async (fail = (error) => { console.log(error); }) => await new Promise((resolve, reject) => {
        captcha
            .onSuccess(() => {
            const result = captcha.getValidate();
            if (result) {
                resolve(result);
            }
        })
            .onFail((data) => {
            fail(data);
        })
            .onError((data) => {
            reject(new BotionError('error', data));
        })
            .onClose(() => {
            reject(new BotionError('close', { message: 'user close' }));
        })
            .showCaptcha();
    });
    // eslint-disable-next-line @typescript-eslint/require-await
    const reset = async () => {
        captcha.reset();
    };
    // eslint-disable-next-line @typescript-eslint/require-await
    const destroy = async () => {
        captcha.destroy();
    };
    return {
        reset,
        destroy,
        show
    };
};
export * from './types';
export { BotionError } from './BotionError';
//# sourceMappingURL=index.js.map